import React, { useState, useRef, useEffect } from 'react';

// Short guidance for the Dictionary selector, shown in a click-to-open popover
// next to the dropdown so users don't have to scroll to the article below.
const INFO = [
  ['TWL', 'North American Scrabble (USA, Canada) — the NASPA tournament list.'],
  ['SOWPODS', 'International Scrabble (UK, Europe, Australia) & world play — the largest list.'],
  ['Words With Friends', "Zynga's mobile app, which uses its own separate dictionary."],
  ['All Dictionaries', 'Combines every list above — the widest possible set of valid words.'],
];

export default function DictInfo() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    function onKey(e) { if (e.key === 'Escape') setOpen(false); }
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDoc); document.removeEventListener('keydown', onKey); };
  }, [open]);

  return (
    <span ref={ref} style={{ position: 'relative', display: 'inline-flex', verticalAlign: 'middle' }}>
      <button
        type="button"
        aria-label="Which dictionary should I choose?"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
        style={{
          width: 18, height: 18, borderRadius: '50%',
          border: 'none', background: '#4f46e5', color: '#fff',
          fontSize: '0.72rem', fontWeight: 800, lineHeight: 1,
          cursor: 'pointer', display: 'inline-flex', alignItems: 'center',
          justifyContent: 'center', fontFamily: 'Georgia, serif', padding: 0,
        }}
      >
        i
      </button>
      {open && (
        <div
          role="tooltip"
          style={{
            position: 'absolute', top: 24, left: 0, zIndex: 1090,
            width: 'min(280px, 78vw)',
            background: '#fff', color: '#374151',
            border: '1px solid var(--border)', borderRadius: 10,
            boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
            padding: '0.75rem 0.85rem',
            fontFamily: 'Nunito, sans-serif', fontSize: '0.82rem', lineHeight: 1.5,
            textAlign: 'left', fontWeight: 500,
          }}
        >
          <div style={{ fontWeight: 800, marginBottom: 6, color: '#1e293b' }}>
            Which dictionary should I choose?
          </div>
          {INFO.map(([name, desc]) => (
            <div key={name} style={{ marginBottom: 6 }}>
              <strong style={{ color: '#4f46e5' }}>{name}</strong> — {desc}
            </div>
          ))}
          <div style={{ marginTop: 4, color: '#64748b', fontSize: '0.78rem' }}>
            Pick the one your game uses. Not sure? <strong>TWL</strong> for US play, <strong>SOWPODS</strong> everywhere else.
          </div>
        </div>
      )}
    </span>
  );
}
